<template>
    <div
        v-if="isShowModal"
        :style="commonConfigStyles"
        class="o-sms-modal-3"
    >
        <OOtgModalContainer
            class="sms-modal-3-container"
            @onClose="onClickClose"
        >
            <section class="sms-modal-otg-wrapper">
                <component
                    :is="component"
                    :itemId="config.itemId"
                    :itemName="config.itemName"
                    :terminalId="config.terminalId"
                    :message="successMessage"
                    class="o-sms-modal-3-component"
                    @smsSendSuccess="onSuccessSend"
                    @smsSendFail="onFailSend"
                />
            </section>
        </OOtgModalContainer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import OSmsModalOtgFail from '../../organisms/o-sms-modal-otg-fail';
import OOtgModalContainer from '../../organisms/o-otg-modal-container';
import OSmsModalOtgSuccess from '../../organisms/o-sms-modal-otg-success';
import OSmsModalOtgInputNumber from '../../organisms/o-sms-modal-otg-input-number';

import { EVENTS, SESSION_TERMINATED } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OSmsModal3',
    components: {
        OSmsModalOtgFail,
        OOtgModalContainer,
        OSmsModalOtgSuccess,
        OSmsModalOtgInputNumber
    },
    data() {
        return {
            isShowModal: false,
            config: {},
            component: 'OSmsModalOtgInputNumber',
            successMessage: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OSmsModal3.styles') || {};
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.deactivateListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.INIT_SMS_MODAL_OTG, this.initModal);
            this.$bus.$on(SESSION_TERMINATED, this.onClickClose);
        },
        deactivateListeners() {
            this.$bus.$off(EVENTS.MODALS.INIT_SMS_MODAL_OTG, this.initModal);
            this.$bus.$on(SESSION_TERMINATED, this.onClickClose);
        },
        initModal(data) {
            this.isShowModal = true;
            this.config = data;
        },
        onClickClose() {
            this.isShowModal = false;
            this.component = 'OSmsModalOtgInputNumber';
            this.config = {};
            this.successMessage = '';
        },
        onSuccessSend(data) {
            this.component = 'OSmsModalOtgSuccess';
            this.successMessage = data;
        },
        onFailSend() {
            this.component = 'OSmsModalOtgFail';
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />